import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./AdHeader.css";
import ScrollReveal from "scrollreveal";

export default function AdHeader({ cartCount, wishlistCount }) {

  
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();

  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".ad-navbar");
      if (window.scrollY > 20) navbar.classList.add("scrolled");
      else navbar.classList.remove("scrolled");
    };

    window.addEventListener("scroll", handleScroll);

    const menuBtn = document.getElementById("menu_btn");
    const navLinks = document.getElementById("nav_links");
    const btnContainer = document.querySelector(".nav_btns"); // Renamed variable
    const menuIcon = document.querySelector("#menu_btn i");

    const toggleMenu = () => {
      navLinks.classList.toggle("open");
      btnContainer.classList.toggle("open"); // Use renamed variable

      const isOpen = navLinks.classList.contains("open");
      menuIcon.className = isOpen ? "ri-close-line" : "ri-menu-line";
    };

    if (menuBtn) menuBtn.addEventListener("click", toggleMenu); // Added null check

    const sr = ScrollReveal({
      distance: "50px",
      origin: "bottom",
      duration: 1000,
    });

    // ScrollReveal code remains the same as it depends on your HTML structure
    sr.reveal(".left h1", { delay: 500 });
    sr.reveal(".left p", { delay: 1000 });
    sr.reveal(".right img", { origin: "right" });
    sr.reveal(".main_btn .btn", { delay: 1500, interval: 300 }); // Added interval
    sr.reveal(".sub_heading", { delay: 500 });
    sr.reveal(".heading", { delay: 500 });
    sr.reveal(".para", { delay: 500 });
    sr.reveal(".box", { delay: 800, interval: 200 }); // Added interval
    sr.reveal(".left_box li", { delay: 500, interval: 100 });
    sr.reveal(".right_box li", { delay: 500, interval: 100 });
    sr.reveal(".box_1", { delay: 1000, interval: 100 });
    sr.reveal(".box_2", { delay: 1000 });
    sr.reveal(".footer_col", { delay: 500, interval: 200 });
    sr.reveal(".footer_bar", { delay: 500 });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (menuBtn) menuBtn.removeEventListener("click", toggleMenu);
    };
  }, []);

  const images = [
    "images/cabinet/vaultx3.png",
    "images/cabinet/solar.png",
    "images/cabinet/cosmic.png",
    "images/cabinet/vaultx4.png",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000); // 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

const navItems = [
  { name: "Dashboard", path: "/admin/dashboard", icon: "ri-dashboard-line" },
  { name: "Product", path: "/admin/product", icon: "ri-shopping-bag-line" },
  { name: "Prebuilt", path: "/admin/prebuild", icon: "ri-computer-line" },
  { name: "Component", path: "/admin/component", icon: "ri-settings-5-line" },
  { name: "Custom PC", path: "/admin/custompc", icon: "ri-cpu-line" },
  { name: "Orders", path: "/admin/order", icon: "ri-file-list-line" },
];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

 return (
  <div id="home">
    <nav className="ad-navbar">
      <div className="ad-logo">
        <img src="/images/logo/logo1.png" />
      </div>

      <ul className="ad-nav_items" id="nav_links">
        {navItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <i className={item.icon}></i> {item.name}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="ad-nav_btns">
        <i className="ri-heart-fill"></i>
        <i className="ri-shopping-cart-fill"></i>

        <div
          className="ad-profile_icon_wrapper"
          tabIndex={0}
          onClick={() => setProfileOpen(!profileOpen)}
          onBlur={() => setProfileOpen(false)}
        >
          <i className="ri-user-fill"></i>

          {profileOpen && (
            <div className="ad-profile_dropdown">
              <p onClick={() => navigate("/profile")}>
                <i className="ri-user-line"></i> Profile
              </p>

              {!localStorage.getItem("token") && (
                <p onClick={() => navigate("/login")}>
                  <i className="ri-login-circle-line"></i> Login
                </p>
              )}

              {localStorage.getItem("token") && (
                <p onClick={handleLogout}>
                  <i className="ri-logout-circle-line"></i> Logout
                </p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="ad-nav_menu" id="menu_btn">
        <i className="ri-menu-line"></i>
      </div>
    </nav>
  </div>
);

}
